module.exports = "/images/Artboard 3 copy 18.svg?a30f1531b3c4079a01628ab1678fd560";